import { render } from "./EventDetails.vue?vue&type=template&id=444239cc"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render

export default script